import { array, object, string } from "yup"
import { isOfficeGroup, officeGroup, offices, mainSite, mainProvider, mainSiteProvider, isSiteGroup, siteGroup, sites } from "@signals"

export const leadingSchema = object({
	startBookingDate: string()
		.required('Booking Start Date is required')
		.matches(/^\d{8}$/, 'Invalid date format (YYYYMMDD)'),
	endBookingDate: string()
		.required('Booking End Date is required')
		.matches(/^\d{8}$/, 'Invalid date format (YYYYMMDD)'),
	startPickupDate: string()
		.required('Pickup Date Range is required')
		.matches(/^\d{8}$/, 'Invalid date format (YYYYMMDD)'),
	endPickupDate: string()
		.required('Pickup End Date is required')
		.matches(/^\d{8}$/, 'Invalid date format (YYYYMMDD)'),
	lor: array()
		.required('Length of Rental is required')
		.min(1, 'Length of Rental is required'),
	currency: string()
		.required('Currency is required'),
	officePickupID: array()
		.test("isOfficePickupID", "Pickup Office is required", () => isOfficeGroup.value || !!offices.value?.length).nullable(),
	officeGroupID: array()
		.test("isOfficeGroupID", "Pickup Office Group is required", () => !isOfficeGroup.value || !!officeGroup.value?.length).nullable(),
	siteMainID: string()
		.test("isSiteMainID", "Main Site is required", () => mainSiteProvider.value || !!mainSite.value).nullable(),
	providerMainID: string()
		.test("isProviderMainID", "Main Provider is required", () => !mainSiteProvider.value || !!mainProvider.value).nullable(),
	groupBy: string().required("Must provide a grouping method"),
})